import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"; // Assuming you use Redux for userwallet
import Cookies from "js-cookie";
import coins from "../image/coins.gif"; // Import the coins image
import {
  carbon_location,
  cross,
  discounticons,
  discounticons2,
  offersicons1,
} from "../imgUrl";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchUserwallet,
  setWallet,
} from "../features/userwallet/userwalletSlice"; // Import action to fetch userwallet
import axios from "axios";
import { toast } from "react-toastify";

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loyalties, setLoyalties] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // console.log("cartItems", cartItems);

  const { wallet } = useSelector((state) => state.userwallet);

  useEffect(() => {
    dispatch(fetchUserwallet()); // Fetch user wallet on component mount
  }, [dispatch]);

  useEffect(() => {
    const fetchLoyalties = async () => {
      try {
        // Get token from localStorage
        const token = localStorage.getItem("token"); // Get token from localStorage

        // Make the API call
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/loyalities`,
          {
            headers: {
              Authorization: token,
            },
          }
        );

        // Set response data to state
        setLoyalties(response.data);
      } catch (error) {
        console.error("Error fetching loyalties:", error);
      }
    };

    fetchLoyalties();
  }, []); // Empty array to run effect only once on component mount

  useEffect(() => {
    const cart = Cookies.get("cart");
    if (cart) {
      setCartItems(JSON.parse(cart));
    }
  }, []);

  const updateQuantity = (index, newQuantity) => {
    if (newQuantity === 0) {
      // If the quantity is 0, remove the item
      removeItem(index);
    } else {
      // Otherwise, update the quantity and price
      const updatedCart = [...cartItems];
      const item = updatedCart[index];
      item.quantity = newQuantity;
      item.price = calculateItemPrice(item);
      setCartItems(updatedCart);
      Cookies.set("cart", JSON.stringify(updatedCart), { expires: 7 });
    }
  };

  const removeItem = (index) => {
    const updatedCart = cartItems.filter((_, i) => i !== index);
    setCartItems(updatedCart);
    Cookies.set("cart", JSON.stringify(updatedCart), { expires: 7 });
  };

  const calculateItemPrice = (item) => {
    const originalPrice = item.variant.price * item.quantity;
    if (item.variant.discountDetails) {
      const { discount, discount_type } = item.variant.discountDetails;
      if (discount_type === "perc") {
        return originalPrice * (1 - discount / 100);
      } else if (discount_type === "fixed") {
        return Math.max(0, originalPrice - discount * item.quantity);
      }
    }
    return originalPrice;
  };

  const calculateTotalDiscount = () => {
    return cartItems.reduce((total, item) => {
      const originalPrice = item.variant.price * item.quantity;
      return total + (originalPrice - item.price);
    }, 0);
  };

  // const getFormattedDeliveryDate = () => {
  //   const deliveryDate = new Date();
  //   deliveryDate.setDate(deliveryDate.getDate() + 7); // Add 7 days to the current date

  //   const options = { day: "numeric", month: "short", year: "numeric" };
  //   const formattedDate = deliveryDate.toLocaleDateString("en-US", options);

  //   const formattedTime = "11:30 PM"; // You can change the delivery time if needed

  //   return `Arriving ${formattedDate}, by ${formattedTime}`;
  // };

  const handleWalletCheckbox = (event) => {
    const token = localStorage.getItem("token"); // Get token from localStorage

    // If the user is not logged in, show the alert
    if (!token) {
      toast.error("Please log in to use wallet coins.");
      dispatch(setWallet(false));
      localStorage.setItem("wallet", false);
    } else {
      console.log(event.target.checked);
      const checkValue = event.target.checked;
      localStorage.setItem("wallet", checkValue);

      dispatch(setWallet(checkValue));
    }
  };

  const totalPrice = cartItems.reduce(
    (total, item) => total + item.variant.price * item.quantity,
    0
  );
  const totalDiscountedPrice = cartItems.reduce(
    (total, item) => total + item.price,
    0
  );
  const totalDiscount = calculateTotalDiscount();
  const deliveryCharge =
    totalPrice >= 499 ? 0 : Number(process.env.REACT_APP_DISCOUNT);

  // Calculate coin discount
  const coinDiscount = wallet && loyalties ? loyalties.coins_amount : 0;

  // Calculate final total
  const finalTotal = Math.max(
    0,
    totalDiscountedPrice + deliveryCharge - coinDiscount
  );

  const validCartItems = cartItems.filter((item) => item.quantity > 0);

  const handleCheckout = () => {
    const checkoutData = {
      products: cartItems.map((item) => ({
        product_id: item.id,
        title: item.title,
        isRequirePrescription: item.isRequirePrescription,
        product_variant_id: item.variant.id || item.variant._id,
        media_id: item.media_id,
        discount_id: item.discount_id,
        price: item.price,
        quantity: item.quantity,
      })),
      shipping_charge: deliveryCharge,
      order_type: "COD",
      total_price: finalTotal,
      use_wallet: wallet,
      coin_discount: coinDiscount,
    };

    navigate("/checkout", { state: { checkoutData } });
  };

  useEffect(() => {
    localStorage.getItem("wallet") === "true"
      ? dispatch(setWallet(true))
      : dispatch(setWallet(false));
  }, []);


  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-lg-8 col-md-6 col-sm-8 col-12 col-xs-12">
          <div className="div-one">
            <h2>My Cart</h2>
            <div className="div-txt-with">
              <div id="img-with-txt">
                <img src={carbon_location} alt="Location" />
                <h5 id="para">
                  Add Address To Unlock Extra Discounts And Best Offers
                </h5>
              </div>
              <Link to="/profile?tab=address-book">
                <h5 id="head-add">ADD ADDRESS</h5>
              </Link>
            </div>
          </div>
          <div className="main-two-div">
            <div className="div-txt-with-item">
              <div id="img-with-txt-item">
                <h3 id="heading-img-item">
                  ITEM(S) IN YOUR CART (
                  {
                    cartItems?.filter((itemData) => itemData?.quantity !== 0)
                      ?.length
                  }
                  )
                </h3>
              </div>
              <Link to="/products">
                <h5 id="head-add-item">ADD ITEMS</h5>
              </Link>
            </div>
            {cartItems
              ?.filter((itemData) => itemData?.quantity !== 0)
              ?.map((item, index) => (
                <>
                  <div className="items-in-cart pt-0 mb-3">
                    <div className="div-txt-with-item-fr">
                      <div id="img-with-txt-item-fr">
                        <h3 id="heading-img-item-fr">Shipment 1</h3>
                      </div>
                      <h5 id="head-add-item-fr">
                        Arriving 25 Dec '24, by 11:30 PM
                      </h5>

                      {/* <h5 id="head-add-item-fr">{getFormattedDeliveryDate()}</h5> */}
                    </div>
                    <div key={index} className="cart-item">
                      <img
                        src={item.image || "images/image (1).png"}
                        // src={item.image }

                        alt={item.title}
                      />
                      <div className="item-details">
                        <div className="item-header">
                          <h3>{item.title}</h3>
                          <img
                            src={cross}
                            id="vec-img-one"
                            onClick={() => removeItem(index)}
                          />
                          {/* <h3 id="vec-img-text-ye">({item.variant.size})</h3> */}
                        </div>
                        <p id="of-per">
                          {item.variant.discountDetails
                            ? item.variant.discountDetails.discount_type ===
                              "perc"
                              ? `${item.variant.discountDetails.discount}% OFF`
                              : `₹${item.variant.discountDetails.discount} OFF`
                            : "No discount"}
                        </p>
                        <div className="price-quantity">
                          <div className="quantity">
                            <button
                              onClick={() =>
                                updateQuantity(
                                  index,
                                  Math.max(0, item.quantity - 1)
                                )
                              }
                            >
                              -
                            </button>

                            <input type="text" value={item.quantity} readOnly />
                            <button
                              onClick={() =>
                                updateQuantity(index, item.quantity + 1)
                              }
                            >
                              +
                            </button>
                          </div>
                          <div className="cart-price">
                            <span>
                              <del>
                                MRP ₹
                                {(item.variant.price * item.quantity).toFixed(
                                  2
                                )}
                              </del>
                            </span>{" "}
                            ₹{item.price.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
          </div>
        </div>
        {validCartItems.length > 0 && (
          <div className="col-lg-4 col-md-6 col-sm-4 col-12 col-xs-12">
            <div>
              {/* Wallet information */}
              <div className="div-tw">
                <h2>Wallet & Coins</h2>
                <div className="div-txt-with-tw">
                  {loyalties && !loyalties.error ? (
                    <div
                      id="img-with-txt-tw"
                      className="justify-content-between"
                    >
                      <div className="use-wallet-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            checked={wallet}
                            onChange={handleWalletCheckbox}
                            className="me-2"
                          />
                          Use wallet coins
                        </label>
                      </div>
                      {wallet && (
                        <span>
                          {loyalties.coins} coins = ₹{loyalties.coins_amount}
                        </span>
                      )}
                      <div>
                        <img
                          src={coins}
                          alt="coins"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <span>{loyalties.coins} coins</span>
                      </div>
                    </div>
                  ) : (
                    <p>No wallet information available.</p>
                  )}
                </div>
              </div>

              {/* Cart breakdown */}
              <div className="cart-div-tw">
                <div className="div-txt-with-item">
                  <div id="img-with-txt-item">
                    <h3 id="heading-img-item">CART BREAKDOWN</h3>
                  </div>
                </div>
                <div className="cart-breakdown">
                  <div className="breakdown-details">
                    <table id="table-sec">
                      <tbody>
                        <tr>
                          <td>
                            <strong>Cart Total</strong>
                          </td>
                          <td>₹{totalPrice?.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Discount on MRP</strong>
                          </td>
                          <td>-₹{totalDiscount?.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Delivery Charges</strong>
                            <span className="cart-symbol">
                              <img src={discounticons2} />
                            </span>
                          </td>
                          <td>
                            <span className="current-price">
                              {deliveryCharge === 0
                                ? "Free"
                                : `₹${deliveryCharge}`}
                            </span>
                          </td>
                        </tr>
                        {wallet && (
                          <tr>
                            <td>
                              <strong>Coin Discount</strong>
                            </td>
                            <td>-₹{coinDiscount?.toFixed(2)}</td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td id="to-pay-sec">
                            <strong>To Pay</strong>
                          </td>
                          <td id="to-pay-sec-tw">
                            <h4>₹ {finalTotal?.toFixed(2)}</h4>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              {/* Savings section */}
              <div className="breakdown-details-tw">
                <div className="header-background">
                  <h3 id="head-kk">
                    You saved ₹{(totalDiscount + deliveryCharge)?.toFixed(2)} on
                    this order
                  </h3>
                </div>
                <table id="table-sec-tw">
                  <tbody id="table-sec-vv">
                    <tr>
                      <td id="saving-jj">
                        <strong className="saving-cl">Savings:</strong>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        <strong className="saving-cl">Discount on MRP:</strong>
                      </td>
                      <td id="price-sec">₹{totalDiscount?.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong className="saving-cl">Free Delivery:</strong>
                      </td>
                      <td>
                        <span className="current-price">₹{deliveryCharge}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Checkout buttons */}
              <div className="amount-sec">
                <div className="amou-price">
                  <h6>Amount to Pay</h6>
                  <span>₹{finalTotal?.toFixed(2)}</span>
                </div>
                <Link to="/profile?tab=address-book" id="add-sc">
                  ADD ADDRESS
                </Link>
              </div>
              <div className="shop-btns">
                <Link to="/products" className="btn">
                  CONTINUE TO SHOPPING
                </Link>
                <br />
                <button onClick={handleCheckout} className="btns">
                  CONTINUE TO CHECKOUT
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
